
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storefront/[storefront]",
      function () {
        return require("private-next-pages/storefront/[storefront].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storefront/[storefront]"])
      });
    }
  